import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: localStorage.getItem('admin_dark_mode') === 'true',
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#FF9800',
        error: '#F44336',
        success: '#4CAF50',
        warning: '#FF9800',
        background: '#FAFAFA',
        surface: '#FFFFFF',
      },
      dark: {
        primary: '#64B5F6',
        secondary: '#B0BEC5',
        accent: '#FFB74D',
        error: '#EF5350',
        success: '#66BB6A',
        warning: '#FFA726',
        background: '#121212',
        surface: '#1E1E1E',
      },
    },
  },
});
